export * from './allocationKey';
export * from './coOwner';
export * from './generalAssembly';
export * from './lot';
export * from './resolution';
export * from './syndic';
export * from './vote';
